define([
	"dojo/_base/declare",
	"SiteAdmin/NewGalleryComment",
	"csi/xml",
], function(declare,NewGalleryComment,xml) {

	return declare(NewGalleryComment, {
		/** we're going to attach the reply through an operation, so set to false */
		bUpdateParent: false,

		preProcess: function() {
			// summary: change current comment to parent rather than sibling
			this.m_urlParent = this.m_urlBefore;
			this.m_urlBefore = null;
			this.inherited(arguments);
		},
		/**
		 * @override
		 * attach the CommentReply using Java Operation
		 */
		toWriter: function() {
			this.inherited(arguments);
			const {m_urlNode, m_urlParent, m_writer} = this;

			// attach the reply
			m_writer
				.callMethod("SiteAdmin", "AttachCommentReply")
				.addParameter(xml.PROP_URL_PARENT, xml.ATTR_REF, m_urlParent)
				.addParameter(xml.PROP_URL, xml.ATTR_REF, m_urlNode);
		},
		
		postProcessSuccess: function() {			
			// summary: add reply to view			
			this.widget.renderReply(this.widget.getContext(this.m_urlNode), this.refNode);
			this.widget.updateActions(this.m_urlParent);
		}
	});
});